<template>
    <div class="business-info-person-declaration">
      <z-fix-top
        keep-position
        class="fixtop"
      >
        <z-nav-bar
            class="navbar"
            left-arrow
            title="个人声明"
            style="background: #F8F8F8"
            @click-left="closePage"
        >
        </z-nav-bar>
      </z-fix-top>
      <section class="selectBusiness" v-if="!isSubmit">
        <div class="desc">{{msg}}</div>
        <z-cell-group inset>
            <div class="title">经营活动类型</div>
            <z-radio-group v-model="radio">
                <z-radio name="1">属于个人销售自产农副产品，依法不需要办理市场主体登记</z-radio>
                <z-radio name="2">属于个人销售家庭手工业产品登记， 依法不需要办理市场主体登记</z-radio>
                <z-radio name="3">属于个人利用自己的技能从事依法无须取得许可的便民劳务活动登记， 依法不需要办理市场主体登记</z-radio>
                <z-radio name="4">属于个人从事零星小额交易活动登记， 依法不需要办理市场主体登记</z-radio>
            </z-radio-group>
        </z-cell-group>
        <z-button size="large" type="primary" :disabled="canSubmit" native-type="submit" @click="submit" btn-class="confirmButton">
              确认声明
        </z-button>
     </section>
     <section class="businessDeclaration"  v-if="isSubmit">
        <z-cell-group inset class="headerGroup">
            <header>经营主体自我声明</header>
            <div class="desc">{{type[personalStatementType]}}</div>
        </z-cell-group>
        <z-cell-group inset v-if="isValidDate">
          <z-cell title="经营主体年检" :is-link="false" value="去更新" label="经营信息有更新" value-class="toSubmit" @click="toSubmit()"/>
        </z-cell-group>
     </section>
    </div>
</template>
<script>
import native from '@zz-common/native-adapter';
import { FixTop, NavBar, Cell, CellGroup, RadioGroup, Radio } from '@zz-common/zz-ui'
import { getCookie, queryParams } from '@lib/utils'
import { getPersonalStatement, submitPersonalStatement } from '@api/resourceApi';
const query = queryParams()

export default {
  name: 'StateComp',
  data() {
    return {
      radio: '',
      from: query.from || this.$route.query.from,
      msg: '根据《中华人民共和国电子商务法》及《网络交易监督管理办法》规定：如您实际经营情况满足以下任一类型则无需办理营业执照。请依照您的自身情况进行选择，提交后平台将就您的选择对外公示。',
      issubmit: query.issubmit || this.$route.query.issubmit,
      type: {
        1: '个人销售自产农副产品，依法不需要办理市场主体登记',
        2: '个人销售家庭手工业产品登记, 依法不需要办理市场主体登记',
        3: '个人利用自己的技能从事依法无须取得许可的便民劳务活动登记, 依法不需要办理市场主体登记',
        4: '个人从事零星小额交易活动登记, 依法不需要办理市场主体登记'
      },
      personalStatementType: '1',
      validDate: 1
    };
  },
  computed: {
    isSubmit() {
      return this.issubmit && this.issubmit != '0';
    },
    isValidDate() {
      return this.validDate && this.validDate != '0';
    },
    canSubmit() {
      return !this.radio;
    }
  },
  methods: {
    closePage() {
      native.close();
    },
    submit() {
      submitPersonalStatement({
        personalStatementType: this.radio,
        sourceCode: this.from
      }).then(() => {
        this.issubmit = 1
        this.initData()
      }).catch(err => {
        console.error(err);
      });
    },
    toSubmit() {
      this.issubmit = 0
    },
    initData() {
      if (this.isSubmit) {
        getPersonalStatement({
          uid: getCookie('uid')
        }).then(res => {
          const { personalStatementType, validDate } = res;
          this.personalStatementType = personalStatementType;
          this.validDate = validDate
        }).catch(err => {
          console.error(err);
        });
      }
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    this.initData()
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-radio-group': RadioGroup,
    'z-radio': Radio,
    'z-cell': Cell,
    'z-cell-group': CellGroup
  }
};
</script>

<style lang='less' scoped>
@import "index.less";
</style>
